// extracted by css-extract-rspack-plugin
export default {"root":"MetricEditorBody-module__root___Yt5cO"};